import React, { useContext } from 'react';

import { debounce } from 'lodash';

import FilterCtx from '../../../../context/filterContext/filterCtx';

import { IDateFilter } from '../../types/IDateFilter';

import { DatePicker } from '@progress/kendo-react-dateinputs';

import '../../datePicker/datePicker.scss';
import '../filters.scss';
import './dateFilter.scss';

const DateFilter: React.FC<IDateFilter> = ({ dateType, disabled, placeholder }) => {
  const filterCtx = useContext(FilterCtx);

  const minDate = new Date(1900, 0, 1);

  const handleDateChange = debounce((event: any) => {
    if (event.value < minDate) return;

    switch (dateType) {
      case 'FROM':
        filterCtx.setFromDate(event.value);
        return;
      case 'TO':
        filterCtx.setToDate(event.value);
        return;
      case 'AS_OF':
        filterCtx.setAsOfDate(event.value);
        return;
    }
  }, 500);

  const getDefaultValue = () => {
    switch (dateType) {
      case 'FROM':
        return new Date(filterCtx.fromDate);
      case 'TO':
        return new Date(filterCtx.toDate);
      case 'AS_OF':
        return new Date(filterCtx.asOfDate);
    }
  };

  return (
    <div className='date-pick-wrapper pointer'>
      {dateType === 'FROM' ? (
        filterCtx.fromDate ? (
          <DatePicker onChange={handleDateChange} disabled={disabled} placeholder={placeholder}
                      defaultValue={getDefaultValue()} />
        ) : (
          <DatePicker onChange={handleDateChange} disabled={disabled} placeholder={placeholder} />
        )
      ) : null}
      {dateType === 'TO' ? (
        filterCtx.toDate ? (
          <DatePicker onChange={handleDateChange} disabled={disabled} placeholder={placeholder}
                      defaultValue={getDefaultValue()} />
        ) : (
          <DatePicker onChange={handleDateChange} disabled={disabled} placeholder={placeholder} />
        )
      ) : null}
      {dateType === 'AS_OF' ? (
        filterCtx.asOfDate ? (
          <DatePicker onChange={handleDateChange} disabled={disabled} placeholder={placeholder}
                      defaultValue={getDefaultValue()} />
        ) : (
          <DatePicker onChange={handleDateChange} disabled={disabled} placeholder={placeholder} />
        )
      ) : null}
    </div>
  );
};

export default DateFilter;
